import Swiper from 'swiper/bundle';

export default function modals() {

    const modalOpen = document.querySelectorAll('.js-modal-open');
    const modalClose = document.querySelectorAll('.js-modal-close');
    const modals = document.querySelectorAll('.modal');
    const videoPlay = document.querySelectorAll('.js-video-play');
    var distance = 0;

    function disable_scroll() {
        document.querySelector("body").classList.add("dis-scroll");
        document.querySelector("body").scrollTo({
          top: distance,
          left: 0,
        });
    }

    function enable_scroll() {

        document.querySelector("body").classList.remove("dis-scroll");

        if ( distance != 0 ) {
            window.scrollTo({
                top: distance,
                left: 0,
            });
        }

    }

    const mainGallerySwiper = new Swiper('.js-gallery-swiper', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        navigation: {
            prevEl: ".modal__gallery-prev",
            nextEl: ".modal__gallery-next",
        },
    });

    if ( modalOpen.length ) {
        for (let open of modalOpen ) {
            open.addEventListener('click',function(e){
                e.preventDefault();

                document.querySelector('.modal.open')?.classList.remove("open");

                let id = open.dataset.modal;
                let modal = document.querySelector(`.modal[data-modal="${id}"]`);
                let slideIndex = open.dataset.slideIndex;

                //document.querySelector('.header__burger_open')?.classList.remove("header__burger_open");
                //document.querySelector('.header__mobile-menu_open')?.classList.remove("header__mobile-menu_open");

                distance = window.pageYOffset;
                disable_scroll();

                if ( modal ) {
                    modal.classList.add("open");

                    if (id == 'photo-gallery') {
                        setTimeout(() => {
                            // Сохраняем текущую скорость анимации
                            const originalSpeed = mainGallerySwiper.params.speed;
                            
                            // Отключаем анимацию
                            mainGallerySwiper.params.speed = 0;
                            mainGallerySwiper.update(); // Обновляем параметры Swiper
                            
                            // Переходим на нужный слайд
                            mainGallerySwiper.slideTo(parseInt(slideIndex));
                            
                            // Восстанавливаем анимацию после перехода
                            setTimeout(() => {
                                mainGallerySwiper.params.speed = originalSpeed;
                                mainGallerySwiper.update();
                            }, 10); // Небольшая задержка для гарантии
                        }, 1);
                    }

                    if ( id == 'video' ) {

                        //let title = open.querySelector('.media__swiper-title').innerHTML;
                        //let type = open.querySelector('.media__swiper-type').innerHTML;
                        //let cover = open.querySelector('.media__swiper-cover img').getAttribute('src');
                        let src = open.dataset.src;
                        //console.log('src', src);
                        //console.log('src', src.split('video-')[1].split('_'));
                        
                        //modal.querySelector('.media__swiper-title').innerHTML = title;
                        //modal.querySelector('.media__swiper-type').innerHTML = type;
                        //modal.querySelector('.media__swiper-cover img').setAttribute('src', cover);

                        let video = modal.querySelector('iframe');
                        //https://vkvideo.ru/video-56610562_456242428
                        //let test = src.split('video-')[1].split('_');
                        //console.log('test', test);
                        //let path = `https://vkvideo.ru/video_ext.php?oid=-${test[0]}&id=${test[1]}&hd=2&autoplay=0`;

                        let path = '';
                        if ( src.includes('oid') ) {
                            //console.log('variant 1');
                            path = `${src}&autoplay=0`;
                        } else {
                            //console.log('variant 2');
                            let test = src.split('video-')[1].split('_');
                            path = `https://vk.com/video_ext.php?oid=-${test[0]}&id=${test[1]}&hd=2&autoplay=0`;
                        }

                        //let path = `${src}&autoplay=0`;
                        video.setAttribute('src', path);
                        /* if ( video.getAttribute('src') != src ) {
                            video.setAttribute('src', src);
                        } */


                    }

                }

                
                
            });
        }
    }


    /* if ( videoPlay.length ) {
        for (let play of videoPlay ) {
            play.addEventListener('click',function(){
                play.classList.add("video-show");
                //play.querySelector('video').play();
                play.innerHTML += `<iframe src="https://vkvideo.ru/video_ext.php?oid=-56610562&id=456242428&hd=2&autoplay=0" width="100%" height="100%" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>`
            });
        }
    } */


    function modal_close() {
        document.querySelector(".modal.open")?.classList.remove("open");

        document.querySelector('iframe')?.setAttribute('src', '');
        /* document.querySelector('.video-show')?.classList.remove("video-show");
        document.querySelector("video")?.pause(); */
    }

    if ( modalClose.length ) {
        for (let close of modalClose ) {
            close.addEventListener('click',function(){
                modal_close();
                enable_scroll();
            });
        }
    }

    document.addEventListener('keydown', function(e) {
        let keyCode = e.keyCode;
        if (keyCode === 27) {
            modal_close();
            enable_scroll();
        }
    });

    if ( modals.length ) {
        for (let modal of modals ) {
            modal.addEventListener('mousedown',function(e){
                if ( e.target.classList.contains("modal") || e.target.classList.contains("modal__scroll") ) {
                    modal_close();
                    enable_scroll();
                }
            });
        }
    }

}